import styled from "styled-components";
import { device } from "../../../../style/styled-components/helpers/device";
// 연혁 한 시기: 왼쪽 시기명·기간, 오른쪽 연도별 타임라인
const HistoryChapter = ({ context }) => {
  return (
    <Div>
      <CategoryTitle>
        <TitleDiv>{context.title}</TitleDiv>
        <RangeDiv>{context.range}</RangeDiv>
      </CategoryTitle>
      <ContentDiv>
        {context.years?.map((x) => (
          <YearDiv key={x.year}>
            <YearSpan>{x.year}</YearSpan>
            <ActionDiv>
              {x.actions?.map((y) => (
                <span key={y}>{y}</span>
              ))}
            </ActionDiv>
          </YearDiv>
        ))}
      </ContentDiv>
    </Div>
  );
};
export default HistoryChapter;
const Div = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;
  background-color: white;
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  padding: 1.75rem 1.25rem;
  @media ${device.tablet} {
    padding: 3rem;
  }
  @media (min-width: 1100px) {
    grid-template-columns: 16rem minmax(0, 1fr);
    gap: 3rem;
  }
`;
const CategoryTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;
const ContentDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  padding-left: 1.75rem;
  &:before {
    content: "";
    position: absolute;
    left: 0.35rem;
    top: 0.5rem;
    bottom: 0.5rem;
    width: 2px;
    background-color: ${({ theme }) => theme.colors.line};
  }
`;
const TitleDiv = styled.div`
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.dark};
`;
const RangeDiv = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.accent};
`;
const YearDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (min-width: 780px) {
    flex-direction: row;
    gap: 2.5rem;
  }
  &:before {
    content: "";
    position: absolute;
    left: -1.75rem;
    top: 0.4rem;
    width: 0.65rem;
    height: 0.65rem;
    border-radius: 50%;
    background-color: white;
    border: 2px solid ${({ theme }) => theme.colors.accent};
  }
`;
const ActionDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.monotone.dark};
`;

const YearSpan = styled.span`
  flex: 0 0 4rem;
  font-size: 1.15rem;
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 800;
  letter-spacing: -0.02em;
`;
